import React, { useState, useEffect } from "react";
import axios from "axios";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { toast } from "react-toastify";

import TableContainer from "../scripts/TableContainer";
import "../../pages/styles/RuleEnrollment.css";

// const config_table_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/view_config_values";
// const config_form_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/manage_config_values";

function ConfigValuesDialog({ open, onClose, config_table_url, config_form_url }) {
  const [configTable, setConfigTable] = useState([]);
  const [config_Key, setConfig_Key] = useState("");
  const [config_Value, setConfig_Value] = useState("");

  const columns = [
    {
      Header: "key",
      accessor: "Config_Key",
    },
    {
      Header: "Value",
      accessor: "Config_Value",
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: (props) => {
        const rowId = props.row.id;
        return <Button onClick={() => selectTableRow(rowId)}>Edit</Button>;
      },
    },
  ];

  useEffect(() => {
    configData();
  }, []);

  function configData() {
    axios.post(config_table_url).then((res) => {
      setConfigTable(res.data.body);
      setConfig_Key(res.data.body[0].Config_Key);
      setConfig_Value(res.data.body[0].Config_Value);
    });
  }

  const createPost = () => {
    axios
      .post(config_form_url, {
        Config_Value: config_Value,
        Config_Key: config_Key,
      })
      .then((res) => {
        if (res) {
          toast.success("Configuration successfully updated");
          configData();
        } else {
          toast.danger("Something went wrong");
        }
      });
  };

  const selectTableRow = (rowId) => {
    console.log(configTable[rowId]);
    setConfig_Key(configTable[rowId].Config_Key);
    setConfig_Value(configTable[rowId].Config_Value);
  };

  // console.log('configTable');
  // console.log(configTable);
  // if (!configTable) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle variant="h6" onClose={onClose} className="dialog-title">
        Configuration Values Management
        {onClose ? <CloseIcon onClick={onClose} /> : null}
      </DialogTitle>
      <DialogContent>
        <hr className="hr-style" />
        <Box
          component="form"
          sx={{
            "& > :not(style)": { width: "32%" },
          }}
          noValidate
          autoComplete="off"
          className="config-textbox"
        >
          <TextField
            className="ruleContainer"
            label="Configuration Key"
            variant="outlined"
            size="small"
            value={config_Key}
            onChange={(e) => setConfig_Key(e.target.value)}
          ></TextField>

          <TextField
            className="ruleContainer"
            label="Configuration Value"
            variant="outlined"
            size="small"
            value={config_Value}
            onChange={(e) => setConfig_Value(e.target.value)}
          ></TextField>
          <Button variant="contained" onClick={createPost}>
            Save
          </Button>
        </Box>

        <Box className="config-table-box">
          <TableContainer columns={columns} data={configTable} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ConfigValuesDialog;
